var React = require('react');

function MagmaLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M176.03 0l80.148 144.044L336.624 0 512 316.365H0L176.03 0zm28.659 291.349h102.697l-51.253-92.113-51.444 92.113zm36.083-119.719l-66.861 119.719H44.674L176.03 55.273l64.742 116.357zm30.767.021l66.602 119.698h129.26L336.533 55.274 271.539 171.65z"}));
}

MagmaLogo.defaultProps = {"viewBox":"0 0 512 317"};

module.exports = MagmaLogo;

MagmaLogo.default = MagmaLogo;
